import { COLLECTIONS } from "constants/action-types";
export const fetchSuggestionsEpic = (action$, store) =>
    action$
        .ofType(COLLECTIONS.COLLECTION.SUGGESTIONS.FETCH.START)
        .map(({ payload }) => payload)
        .switchMap(({ data, storeKey }) => {
            const {
                collection: { suggestions },
            } = store.getState();
            const newSuggestions = { ...suggestions };
            if (newSuggestions[storeKey] === undefined) {
                newSuggestions[storeKey] = data;
            }
            return [
                {
                    payload: newSuggestions,
                    type: COLLECTIONS.COLLECTION.SUGGESTIONS.FETCH.COMPLETED,
                },
            ];
        });
